<template>
  <div class="admin-layout" ref="adminLayout">
    <!-- 左边菜单栏  -->
    <div class="left-menu" id="left-menu" v-if="hiden" :class="{
      'mobile-class': isMobile
    }">
      <LeftMenu></LeftMenu>
    </div>
    <!-- 中间路由区 -->
    <div class="router-view">
      <div v-if="!isVoiceCall">
        <div v-if="!hiden && $route.path.indexOf('knowledge') == -1" style="height: 44px;"></div>
        <div class="router-view-top" :class="{
          fixedTop:!hiden,
        }" v-if="((isShowForm || !hiden) && $route.path.indexOf('knowledge') == -1)">

            <!-- 展开折叠 -->
            <div v-if="!hiden" class="btn-div-im-2" @click="leftVisible = true">
              <img :src="navExpand" alt="" class="nav-fold" />
            </div>

            <div>
              <SelectTank v-if="isTank"></SelectTank>
              <!-- 移动端的标题 -->
              <div class="hiden_title" v-if="!isTank && !hiden">{{ title }}</div>
            </div>

            <div style="display: flex;align-items: center;gap: 10px">
              <div v-if="!hiden && !isSet" class="btn-div-img" @click="mobileSetClearFn">
                <img :src="newIcon" alt="" class="btn_icon" />
              </div>
            </div>

          </div>
      </div>


      <a-config-provider :locale="zhCN">
        <keep-alive v-if="$route.meta.keepAlive">
          <router-view style="height: 100px;flex: 1"></router-view> 
        </keep-alive>
        <router-view v-else style="height: 100px;flex: 1"></router-view>
      </a-config-provider>

      <Footer v-if="$route.path.indexOf('knowledge') == -1 && !isVoiceCall"></Footer>
    </div>
    <!-- 右侧功能区 -->
    <div class="right-menu" v-if="isShowResources">
      <div class="right-contet">
        <RightMenu :visible.sync="isShowResources"></RightMenu>
      </div>

      <div class="right-drawer">
        <a-drawer
            placement="right"
            :closable="false"
            width="384px"
            :get-container="false"
            :visible="isShowResources"
        >
          <RightMenu :visible.sync="isShowResources"></RightMenu>
        </a-drawer>

      </div>

    </div>

    <a-modal
        :visible="visible"
        destroyOnClose
        :footer="null"
        :getContainer="getContainerFn"
        centered
    >
      <DialogueForm :visible.sync='visible'></DialogueForm>
    </a-modal>

    <!-- 移动端菜单栏 -->
    <DrawerLeftMenu :visible.sync="leftVisible"></DrawerLeftMenu>
  </div>
</template>

<script>
// import formIcon from '@/assets/form-icon.png'
import LeftMenu from './components/LeftMenu.vue'
import DialogueForm from "@/components/DialogueForm.vue"
import {mapState, mapMutations, mapGetters} from 'vuex'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import Footer from './components/Footer.vue' 
import SelectTank from '@/components/SelectTank.vue'
import RightMenu from '@/components/rightMenu/RightMenu.vue'
import navExpand from '@/assets/nav-expand.png'
import { getParameters } from '@/services/difyApi'
import { strategyList } from '@/services/set'
import DrawerLeftMenu from './components/DrawerLeftMenu.vue'
import newIcon from '@/assets/new-icon.png'

export default {
  components: {
    LeftMenu,
    Footer,
    DialogueForm,
    RightMenu,
    SelectTank,
    DrawerLeftMenu
  },
  computed: {
    ...mapState('channel', ['isLogin']),
    ...mapState('audio', ['isVoiceCall']),
    ...mapState('mobile', ['isMobile']),
    ...mapState('agent', ['currentAgentData','defaultConfig']),
    ...mapState('message', ['clear']),
    ...mapState('resources', ['isShowResources']),
    ...mapGetters('aiConfig',{
      userForm:'userForm'
    }),
    title(){
      let titleMap = {
        'setting':'设置',
        'home':'AI会话',
        'tank':'AI会话',
        'tankList':'维盾智库',
        'history':'历史会话',
      }
      return titleMap[this.$route.name]
    },
    routersViewHeight(){
      if(!this.isShowForm){
        return 'calc(100vh - 20px - 32px)'
      }else{
        if(this.isVoiceCall){
          return 'calc(100vh - 64px)'
        }
        return 'calc(100vh - 44px - 20px - 32px)'
      }
    },
    isSet(){
      if(this.$route.path == '/setting'){
        return true
      }else{
        return false
      }
    },
    isTank(){
      if(this.$route.path == '/tank'){
        return true
      }else{
        return false
      }
    },
    isShowForm(){
      let routers = ['/tankList','/history','/setting']
      if(routers.includes(this.$route.path)){
        return false
      }else{
        return true
      }
    }
  },
  watch:{
    '$route':{
      immediate:true,
      handler(){
        this.visible = false
        this.setShow(false)
        let agentId = ''
        if(this.$route.path == '/tank'){
          agentId = this.currentAgentData.agentId
          this.getParametersFn(this.currentAgentData.agentId)
        }
        if(this.$route.path == '/ai'){
          agentId = this.defaultConfig.agentId
          this.getParametersFn(this.defaultConfig.agentId)
        }
      }
    },
    clear:{
      handler(){
        this.setShow(false)
        if(this.defaultConfig){
          if(this.$route.path == '/ai'){
              this.getParametersFn(this.defaultConfig.agentId)
          }
        }
      }
    },
    currentAgentData:{
      handler(val) {
        if(this.$route.name == 'tank'){
          this.getParametersFn(this.currentAgentData.agentId)
        }
      },
      deep: true,
    },
    // defaultConfig:{
    //   handler(val) {
    //     if(this.$route.name == 'home'){
    //       this.getParametersFn(val.agentId)
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  data() {
    return {
      zhCN,
      // formIcon,
      newIcon,
      navExpand,
      hiden:true,
      // isShowResources:true,
      visible:false,
      leftVisible:false,
      isShowDialogueForm:false,
    }
  },
  created(){
    this.getStrategyList()
  },
  mounted(){
    this.resizeScran()
    window.addEventListener('resize', () => {
      this.resizeScran()
    })
  },
  methods: {
    ...mapMutations('aiConfig', ['setConfig','setStragyData']),
    ...mapMutations('mobile',['setMobile']),
    ...mapMutations('message',['setClear']),
    ...mapMutations('agent',['clearCurrentAgent']),
    ...mapMutations('resources',['setShow']),
    formClick(){
      this.visible = !this.visible
      document.getElementById('btnDivImg').classList.remove('blink');
    },
    getContainerFn() {
      return false
    },
    mobileSetClearFn(){
      if(this.$route.name == 'tank'){
        this.setTankClearFn()
      }else{
        this.setClearFn()
      }
    },
    setTankClearFn(){
      if(this.$route.fullPath != '/tank'){
        this.$router.replace('/tank')
      }
      this.$emit('drawerChange')
      setTimeout(() => {
        this.setClear()
      }, 500)
    },
    setClearFn(){
      if(this.$route.fullPath != '/ai'){
        this.$router.replace('/ai')
      }
      this.clearCurrentAgent()
      this.$emit('drawerChange')
      setTimeout(() => {
        this.setClear()
      }, 500)
    },
    resizeScran() { 
      this.setMobile(window.innerWidth < 994 && window.innerWidth > 680)
      if(window.innerWidth < 680){
        this.hiden = false
      }else{
        this.hiden = true
      }
    },
    async getStrategyList(){
      
      // if(this.isLogin && !localStorage.getItem('web_login_token')) return
      if(!localStorage.getItem('web_login_token')) return

      let res = await strategyList()
      let obj = {}
      if(res.code == 200){
        res.data.forEach(item => {
          obj[item.key] = item.value
        })
        this.setStragyData(obj)
      }

    },
    // 获取参数
    async getParametersFn(data){
      if(!localStorage.getItem('web_login_token') || !data) return
      try {
        let res = await getParameters(data)
        let { userInputForm } = res
        if(userInputForm && userInputForm.length){
          this.isShowDialogueForm = true
        }else{
          this.isShowDialogueForm = false
        }
        this.setConfig(res)
      } catch (error) {}
      
    },
    
  }
}
</script>

<style lang="scss" scoped>
@import "@/bootstrap/layout.bootstrap.scss";

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
.hiden_title{
  font-weight: bold;
  font-size: 16px;
  color: #2C2C2C;
  line-height: 21px;
  text-align: center;
}
::v-deep .ant-drawer-body{
  padding: 0 !important;
}
.right-drawer{
  display: none;
}
.btn_icon{
  width: 20px;
  height: 20px;
}
.blink {
  background: #FB9A0E;
  border-radius: 10px;
  animation: blink 1s infinite; /* 动画名称，持续时间，循环次数 */
}
.btn-div-im-2{
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .nav-fold{
        width: 20px;
        height: 20px;
    }
}
.admin-layout{
  display: flex;
  background: #fff;
  min-height: 100vh;
  
  .fixedTop{
    position: fixed;
    top: 0;
    right: 0;
    background: #FCFCFD;
    z-index: 9;
    border-bottom: 1px solid #E6E6E6;
    height: 44px !important;
  }
  .router-view-top{
    width: 100%;
    height: 64px;
    background: #FCFCFC;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    box-sizing: border-box;
    
    .btn-div-img{
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .nav-fold{
        width: 20px;
        height: 20px;
      }
    }
  }
  .btn-div-img:hover{
    background: rgba(1,10,28,0.05);
    border-radius: 4px;
  }
  .router-view{
    flex: 1;
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    // background: linear-gradient( 180deg, #FFFFFF 0%, #F4F7FD 100%);
    background: linear-gradient( 180deg, rgba(26,94,240,0) 0%, rgba(26,94,240,0.03) 100%);
    display: flex;
    flex-direction: column;
  }
  .left-menu{
    width: 260px;
    height: 100vh;
    background: #F0F3F8;
  }
  .mobile-class{
    width: 78px;
    overflow: hidden;
  }
  ::v-deep .ant-popover-inner-content{
    padding: 0 !important;
  }
}
::v-deep .ant-modal-body{
  padding: 0 !important;
}
::v-deep .ant-modal-close{
  display: none !important;
}
</style>